import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Alert,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledTooltip,
} from "reactstrap";
import Switch from "react-switch";
import classnames from "classnames";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import Dropzone from "react-dropzone";
import { useSelector } from "react-redux";
// Redux
import { withRouter, Link } from "react-router-dom";

// Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
// availity-reactstrap-validation
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import {
  Fn_DisplayData,
  Fn_AddEditData,
  Fn_FillListData,
  Fn_ChangeStateValue,
} from "../../store/functions";

export const DateString = dd => {
  let d1 = dd.replace("-", "");
  let d2 = d1.replace("-", "");

  return d2;
};

class Screen1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      formData: {},
      activeTab: 1,
      passedSteps: [1],
      BrowseImage1: "",
      BrowseImage2: "",
      UserImage: "",
      Signature: "",
      //dropdowns
      membershipType: [],
      maritalStatus: [],
      bloodGroup: [],
      gender: [],
      education: [],
      profession: [],
      relationShip: [],
      nationality: [],
      typeofRegCert: [],
      memberid: 0,
      name: "",
      email: "",
      aid: 0,
      fo3: false,
      Gender: 0,
      MaritalStatus: 0,
      success_msg: false,
      F_MISScheme: 0,
      IsOvertime: false,
      EmpBasic: [],
      searchText: '',
    };
    this.obj = this;
    this.nameFieldRef = React.createRef();
    this.formTitle = "User";
    this.breadCrumbTitle = "User Master";
    this.breadCrumbItem = "Add " + this.formTitle;
    this.API_URL = API_WEB_URLS.MASTER + "/0/token/User";
    this.API_URL_SAVE = API_WEB_URLS.UserMaster + "/0/token";
    this.pushFormName = "/UserMaster";
    this.rtPage_Print = "/membersynopsisprint";

    //Event Binding
    this.btnSave_onClick = this.btnSave_onClick.bind(this);
    this.btnCancel_onClick = this.btnCancel_onClick.bind(this);
    this.btnGoBack_onClick = this.btnGoBack_onClick.bind(this);
  }

  componentDidMount() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    if (this.nameFieldRef.current) {
      this.nameFieldRef.current.focus();
    }
    this.setState({
      name: obj.username,
      email: obj.email,
      aid: obj.uid,
      role: obj.role,
    });
    
    Fn_FillListData(
      this.obj,
      "UserType",
      API_WEB_URLS.MASTER + "/0/token/UserType/Id/0"
    );
    //Filling DropDowns
   
    const { id } = this.props.match.params;
    if (id) {
      this.setState({ id: id });
      this.breadCrumbItem = "Edit " + this.formTitle;
      Fn_DisplayData(this.obj, id, this.API_URL + "/Id");
    } else {
      this.setState({ id: 0 });
    }
  }

  btnSave_onClick(event, formData) {
    let vformData = new FormData();

    vformData.append("Name", formData.Name);
    vformData.append("Password", formData.Password);
    vformData.append("F_UserType", formData.F_UserType);
    vformData.append("UserId", this.state.aid);
    if (!this.state.id) {
      Fn_AddEditData(
        this.obj,
        { arguList: { id: 0, formData: vformData } },
        this.API_URL_SAVE,
        this.pushFormName,
        true,
        "memberid"
      );
    } else
      Fn_AddEditData(
        this.obj,
        { arguList: { id: this.state.id, formData: vformData } },
        this.API_URL_SAVE,
        this.pushFormName,
        true,
        "kuku"
      );

  }

  btnGoBack_onClick = event => {
    event.preventDefault();
    //this.props.history.goBack();
    this.props.history.push(this.pushFormName);
  };

  btnCancel_onClick = event => {
    event.preventDefault();
    //this.props.history.goBack();
    this.props.history.push(this.pushFormName);
  };

  render() {
    return (
      <div className="page-content">
        <React.Fragment>
          <Container fluid>
            {/* Header Section */}
            <div className="text-center mb-5" style={{ marginTop: '20px' }}>
              <i className="mdi mdi-cellphone-basic font-size-100" 
                 style={{ 
                   color: '#4B4B7C',
                   fontSize: '100px', // Explicit size in pixels
                   display: 'block',
                   margin: '20px 0'
                 }}></i>
              
            </div>

            {/* Search Section */}
            <Row className="justify-content-center mb-5">
              <Col lg="6">
                <div className="search-box">
                  <div className="position-relative" 
                       style={{ 
                         boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                         borderRadius: '8px',
                         overflow: 'hidden'
                       }}>
                    <Input 
                      type="text" 
                      placeholder="Search ..."
                      value={this.state.searchText}
                      onChange={(e) => this.setState({ searchText: e.target.value })}
                      style={{
                        height: '50px',
                        border: 'none',
                        paddingLeft: '20px',
                        fontSize: '16px'
                      }}
                    />
                    <Button 
                      color="primary"
                      style={{
                        position: 'absolute',
                        right: '0',
                        top: '0',
                        height: '50px',
                        width: '50px',
                        borderRadius: '0 8px 8px 0'
                      }}
                    >
                      <i className="mdi mdi-magnify font-size-18"></i>
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>

            {/* Services Cards */}
            <Row className="justify-content-center">
              <Col lg="3" md="6" className="mb-4">
                <Card className="service-card" 
                      style={{ 
                        transition: 'transform 0.3s, box-shadow 0.3s',
                        cursor: 'pointer',
                        borderRadius: '12px',
                        border: 'none',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                      }}
                      onMouseOver={e => {
                        e.currentTarget.style.transform = 'translateY(-5px)';
                        e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.15)';
                      }}
                      onMouseOut={e => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                      }}>
                  <CardBody className="text-center p-4">
                    <div className="service-icon mb-4" 
                         style={{ 
                           backgroundColor: '#f0f3ff',
                           width: '70px',
                           height: '70px',
                           borderRadius: '50%',
                           display: 'flex',
                           alignItems: 'center',
                           justifyContent: 'center',
                           margin: '0 auto'
                         }}>
                      <i className="mdi mdi-bank font-size-24" style={{ color: '#4B4B7C' }}></i>
                    </div>
                    <CardTitle tag="h5" className="mb-3">Open Account</CardTitle>
                    <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
                      Create a new bank account instantly
                    </p>
                  </CardBody>
                </Card>
              </Col>

              <Col lg="3" md="6" className="mb-4">
                <Card className="service-card" 
                      style={{ 
                        transition: 'transform 0.3s, box-shadow 0.3s',
                        cursor: 'pointer',
                        borderRadius: '12px',
                        border: 'none',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                      }}
                      onMouseOver={e => {
                        e.currentTarget.style.transform = 'translateY(-5px)';
                        e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.15)';
                      }}
                      onMouseOut={e => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                      }}>
                  <CardBody className="text-center p-4">
                    <div className="service-icon mb-4" 
                         style={{ 
                           backgroundColor: '#fff4f0',
                           width: '70px',
                           height: '70px',
                           borderRadius: '50%',
                           display: 'flex',
                           alignItems: 'center',
                           justifyContent: 'center',
                           margin: '0 auto'
                         }}>
                      <i className="mdi mdi-file-document font-size-24" style={{ color: '#ff8c42' }}></i>
                    </div>
                    <CardTitle tag="h5" className="mb-3">Wallet KYC</CardTitle>
                    <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
                      Complete your KYC verification
                    </p>
                  </CardBody>
                </Card>
              </Col>

              <Col lg="3" md="6" className="mb-4">
                <Card className="service-card" 
                      style={{ 
                        transition: 'transform 0.3s, box-shadow 0.3s',
                        cursor: 'pointer',
                        borderRadius: '12px',
                        border: 'none',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                      }}
                      onMouseOver={e => {
                        e.currentTarget.style.transform = 'translateY(-5px)';
                        e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.15)';
                      }}
                      onMouseOut={e => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                      }}>
                  <CardBody className="text-center p-4">
                    <div className="service-icon mb-4" 
                         style={{ 
                           backgroundColor: '#f0fff4',
                           width: '70px',
                           height: '70px',
                           borderRadius: '50%',
                           display: 'flex',
                           alignItems: 'center',
                           justifyContent: 'center',
                           margin: '0 auto'
                         }}>
                      <i className="mdi mdi-download font-size-24" style={{ color: '#2ed573' }}></i>
                    </div>
                    <CardTitle tag="h5" className="mb-3">Download</CardTitle>
                    <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
                      Access important documents
                    </p>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </React.Fragment>
      </div>
    );
  }
}
export default compose(container)(Screen1);
